<template>
  <v-dialog v-model="value" width="1000" @keydown.esc="dismiss()" persistent>
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center blue white--text py-2">
        <template v-if="type == 'invoice'">{{ $t('invoice.title') }}</template>
        <template v-else-if="type == 'receipt'">{{ $t('bill.receipt') }}</template>
        <template v-else-if="type == 'quotation'">{{ $t('bill.quotation') }}</template>
        <template v-else-if="type == 'appeal'">{{ $t('area.deposit_market_document') }}</template>
        <template v-else-if="type == 'booking'">{{ $t('booking.booking_board') }}</template>
        <template v-else-if="type == 'credit-note'">{{ $t('credit_note.title') }}</template>
      </v-card-title>

      <div v-show="isData">
        <v-card-text class="px-0 py-0" v-show="!isLoading && !isLoadIframe">
          <iframe v-if="language" src width="100%" height="500px" frameborder="0" :name="this.elementId || 'printIframe'"
            :id="this.elementId || 'printIframe'" @load="() => isLoadIframe = false" lazy></iframe>
        </v-card-text>

        <v-card-text class="px-0 py-0">
          <v-card class="justify-center py-10 d-flex" v-if="isLoading || isLoadIframe" elevation="0">
            <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
          </v-card>
        </v-card-text>

        <v-divider></v-divider>
      </div>

      <template v-if="!isData">
        <v-card-text class="px-0 py-4 text-center">
          <h4 class="text-center" v-if="type == 'invoice'">{{ $t('invoice.no_invoice_bill') }}</h4>
          <h4 class="text-center" v-else-if="type == 'receipt'">{{ $t('bill.no_receipt') }}</h4>
          <h4 class="text-center" v-else-if="type == 'quotation'">{{ $t('bill.no_quotation') }}</h4>
          <h4 class="text-center" v-else-if="type == 'appeal'">{{ $t('appeal.no_any_appeal') }}</h4>
          <h4 class="text-center" v-else-if="type == 'booking'">{{ $t('booking.no_booking_board') }}</h4>
          <h4 class="text-center" v-else-if="type == 'credit-note'">{{ $t('credit_note.no_credit_note') }}</h4>
        </v-card-text>
      </template>

      <v-card-actions>
        <v-select v-if="type == 'invoice' || type == 'receipt' || type == 'credit-note' || type == 'quotation'" v-model="language" outlined color="info" hide-details solo
          :items="[{ value: 'th', text: $t('language.th') }, { value: 'en', text: $t('language.en') }, { value: 'lo', text: $t('language.lo') }]" :no-data-text="$t('noinfo')"></v-select>
        <v-spacer></v-spacer>
        <v-btn color="default" @click="dismiss()">{{ $t('close') }}</v-btn>
        <v-btn color="info" :disabled="isLoading || !isData" @click="print()">
          <v-icon dark class="me-2">mdi-printer</v-icon>{{ $t('print') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    invoiceIds: Array,
    receiptIds: Array,
    type: String,
    elementId: String,
    quotationIds: Array,
    appealId: String,
    bookingId: String,
    creditNoteIds: Array,
    lang: {
      default: "th",
      type: String
    }
  },
  data() {
    return {
      isLoading: false,
      isLoadIframe: false,
      language: this.$i18n.locale.split('-')[0],
      PRINT_SERVER_URL:
        process.env.VUE_APP_PRINT_SERVER_URL ||
        "https://market-print-dev-bq4s7k7bea-as.a.run.app"
    };
  },
  watch: {
    value(newv) {
      if (newv) this.initData();
    },
    language(value) {
      if (value) {
        this.isLoadIframe = true
        this.initData();
      }
    }
  },
  computed: {
    isData() {
      if (this.type == "invoice" && this.invoiceIds && this.invoiceIds.length)
        return true;
      else if (
        this.type == "receipt" &&
        this.receiptIds &&
        this.receiptIds.length
      )
        return true;
      else if (
        this.type == "quotation" &&
        this.quotationIds &&
        this.quotationIds.length
      )
        return true;
      else if (this.type == "appeal" && this.appealId) return true;
      else if (this.type == "booking" && this.bookingId) return true;
      else if (
        this.type == "credit-note" &&
        this.creditNoteIds &&
        this.creditNoteIds.length
      )
        return true;
      else return false;
    },
    user() {
      return this.$store.getters["user/getUser"];
    }
  },
  methods: {
    async initData() {
      let sessionToken = "";
      if (localStorage.getItem("sessionToken")) {
        sessionToken = localStorage.getItem("sessionToken");
      }
      if (this.type == "invoice") {
        if (this.invoiceIds && this.invoiceIds.length) {
          this.isLoading = true;
          setTimeout(async () => {
            let form = document.createElement("form");
            let body = {
              ids: JSON.stringify(this.invoiceIds),
              sessionToken,
              lang: this.language
            };
            form._submit_function_ = form.submit;
            form.setAttribute("method", "post");
            form.setAttribute("action", this.PRINT_SERVER_URL + "/invoice");
            form.setAttribute("target", this.elementId || "printIframe");
            for (var key in body) {
              var hiddenField = document.createElement("input");
              hiddenField.setAttribute("type", "hidden");
              hiddenField.setAttribute("name", key);
              hiddenField.setAttribute("value", body[key]);
              form.appendChild(hiddenField);
            }
            document.body.appendChild(form);
            form._submit_function_(); //Call the renamed function.
            this.isLoading = false;
          }, 500);
        }
      } else if (this.type == "receipt") {
        if (this.receiptIds && this.receiptIds.length) {
          this.isLoading = true;
          setTimeout(() => {
            let form = document.createElement("form");
            let body = {
              ids: JSON.stringify(this.receiptIds),
              printBy: `${this.user.firstName || ""} ${this.user.lastName ||
                ""}`,
              sessionToken,
              lang: this.language
            };
            form._submit_function_ = form.submit;
            form.setAttribute("method", "post");
            form.setAttribute("action", this.PRINT_SERVER_URL + "/receipt");
            form.setAttribute("target", this.elementId || "printIframe");
            for (var key in body) {
              var hiddenField = document.createElement("input");
              hiddenField.setAttribute("type", "hidden");
              hiddenField.setAttribute("name", key);
              hiddenField.setAttribute("value", body[key]);
              form.appendChild(hiddenField);
            }
            document.body.appendChild(form);
            form._submit_function_(); //Call the renamed function.
            this.isLoading = false;
          }, 500);
        }
      } else if (this.type == "quotation") {
        if (this.quotationIds && this.quotationIds.length) {
          this.isLoading = true;
          setTimeout(() => {
            let form = document.createElement("form");
            let body = {
              ids: JSON.stringify(this.quotationIds),
              sessionToken,
              lang: this.language
            };
            form._submit_function_ = form.submit;
            form.setAttribute("method", "post");
            form.setAttribute("action", this.PRINT_SERVER_URL + "/quotation");
            form.setAttribute("target", this.elementId || "printIframe");
            for (var key in body) {
              var hiddenField = document.createElement("input");
              hiddenField.setAttribute("type", "hidden");
              hiddenField.setAttribute("name", key);
              hiddenField.setAttribute("value", body[key]);
              form.appendChild(hiddenField);
            }
            document.body.appendChild(form);
            form._submit_function_(); //Call the renamed function.
            this.isLoading = false;
          }, 500);
        }
      } else if (this.type == "appeal") {
        if (this.appealId) {
          this.isLoading = true;
          setTimeout(() => {
            let form = document.createElement("form");
            let body = {
              ids: JSON.stringify(this.appealId),
              sessionToken,
              lang: this.language
            };
            form._submit_function_ = form.submit;
            form.setAttribute("method", "post");
            form.setAttribute("action", this.PRINT_SERVER_URL + "/appeal");
            form.setAttribute("target", this.elementId || "printIframe");
            for (var key in body) {
              var hiddenField = document.createElement("input");
              hiddenField.setAttribute("type", "hidden");
              hiddenField.setAttribute("name", key);
              hiddenField.setAttribute("value", body[key]);
              form.appendChild(hiddenField);
            }
            document.body.appendChild(form);
            form._submit_function_(); //Call the renamed function.
            this.isLoading = false;
          }, 500);
        }
      } else if (this.type == "booking") {
        if (this.bookingId) {
          this.isLoading = true;
          setTimeout(() => {
            let form = document.createElement("form");
            let body = {
              id: JSON.stringify(this.bookingId),
              sessionToken,
              lang: this.language
            };
            form._submit_function_ = form.submit;
            form.setAttribute("method", "post");
            form.setAttribute("action", this.PRINT_SERVER_URL + "/booking");
            form.setAttribute("target", this.elementId || "printIframe");
            for (var key in body) {
              var hiddenField = document.createElement("input");
              hiddenField.setAttribute("type", "hidden");
              hiddenField.setAttribute("name", key);
              hiddenField.setAttribute("value", body[key]);
              form.appendChild(hiddenField);
            }
            document.body.appendChild(form);
            form._submit_function_(); //Call the renamed function.
            this.isLoading = false;
          }, 500);
        }
      } else if (this.type == "credit-note") {
        if (this.creditNoteIds && this.creditNoteIds.length) {
          this.isLoading = true;
          setTimeout(() => {
            let form = document.createElement("form");
            let body = {
              ids: JSON.stringify(this.creditNoteIds),
              sessionToken,
              lang: this.language
            };
            form._submit_function_ = form.submit;
            form.setAttribute("method", "post");
            form.setAttribute("action", this.PRINT_SERVER_URL + "/creditnote");
            form.setAttribute("target", this.elementId || "printIframe");
            for (var key in body) {
              var hiddenField = document.createElement("input");
              hiddenField.setAttribute("type", "hidden");
              hiddenField.setAttribute("name", key);
              hiddenField.setAttribute("value", body[key]);
              form.appendChild(hiddenField);
            }
            document.body.appendChild(form);
            form._submit_function_(); //Call the renamed function.
            this.isLoading = false;
          }, 500);
        }
      }
    },
    print() {
      let PDF = document.getElementById(this.elementId || "printIframe");
      PDF.focus();
      try {
        PDF.contentWindow.print();
      } catch (ex) {
        PDF.contentWindow.postMessage("print", "*");
      }
    },
    dismiss() {
      document
        .getElementById(this.elementId || "printIframe")
        .setAttribute("src", "");
      this.$emit("input", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-input {
  max-width: 130px;
  min-height: 10px;

  ::v-deep {
    .v-input__slot {
      min-height: 36px;
    }

    .v-input__control {
      justify-content: center;
    }
  }

}
</style>